// Campus photo for /colleges/case-western-reserve-university: Public domain, by Daderot, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAdelbert_Hall_-_Case_Western_Reserve_University.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/case-western-reserve-university/; credited under the photo.
const photo = {
    "slug": "case-western-reserve-university",
    "alt": "Adelbert Hall, built in 1882, across a lawn at Case Western Reserve University in Cleveland, Ohio",
    "src": "/colleges/case-western-reserve-university/campus-1600.webp",
    "srcSmall": "/colleges/case-western-reserve-university/campus-800.webp",
    "srcMid": "/colleges/case-western-reserve-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/case-western-reserve-university/og.jpg",
    "title": "Adelbert Hall - Case Western Reserve University",
    "author": "Daderot",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAdelbert_Hall_-_Case_Western_Reserve_University.jpg",
    "read": "2026-10-01"
};

export default photo;
